import { render, staticRenderFns } from "./ed-content-sidebar-open-arrow.component.vue?vue&type=template&id=60c904f8&scoped=true&"
import script from "./ed-content-sidebar-open-arrow.component.ts?vue&type=script&lang=ts&"
export * from "./ed-content-sidebar-open-arrow.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-content-sidebar-open-arrow.component.scss?vue&type=style&index=0&id=60c904f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c904f8",
  null
  
)

export default component.exports